import ExternalApiKeyModal from "./ExternalApiKeyModal";
import ApiKeySection from "./ApiKeySection";
import Constants from "../../../../Constants";

const ExternalApiKeySec = () => {
  return (
    <ApiKeySection
      title="Integration Partners"
      buttonText="Add Integration Partner Key"
      modal={ExternalApiKeyModal}
      getApiUrl={Constants.ApiUrl.user.getPartnerApiKeys}
      deleteApiUrl={Constants.ApiUrl.user.revokePartnerApiKey}
    />
  );
};

export default ExternalApiKeySec;
